import React from 'react';
import { PropTypes } from 'prop-types';

const ThreeDotIcon = () => (
    <svg width="4" height="16" viewBox="0 0 4 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M-8.74228e-08 2C-1.35705e-07 3.10457 0.89543 4 2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 -3.91405e-08 2 -8.74228e-08C0.895431 -1.35705e-07 -3.91405e-08 0.89543 -8.74228e-08 2Z"
            fill="#020202"
        />
        <path
            d="M-8.74228e-08 8C-1.35705e-07 9.10457 0.89543 10 2 10C3.10457 10 4 9.10457 4 8C4 6.89543 3.10457 6 2 6C0.895431 6 -3.91405e-08 6.89543 -8.74228e-08 8Z"
            fill="#020202"
        />
        <path
            d="M-8.74228e-08 14C-1.35705e-07 15.1046 0.89543 16 2 16C3.10457 16 4 15.1046 4 14C4 12.8954 3.10457 12 2 12C0.895431 12 -3.91405e-08 12.8954 -8.74228e-08 14Z"
            fill="#020202"
        />
    </svg>
);

// ThreeDotIcon.propTypes = {
//     prop: PropTypes.
// };

export default ThreeDotIcon;
